module.exports = __webpack_public_path__ + "static/img/loading.a60b5f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/loading.png
// module id = jrhY
// module chunks = 0